import React from 'react';
import PropTypes from 'prop-types';
import css from './CwToggleButton.scss';
import cx from 'classnames';
import CwImage from '../cwimage/CwImage';

class CwToggleButton extends React.Component {

  handleClick = () => {
    if (!this.props.onClick) {
      return;
    }
    
    this.props.onClick(this.props.item);
  }

  handleKeyPress = (event) => {
    if (!this.props.onClick || event.which !== 32) {
      return;
    }
    this.props.onClick(this.props.item);
  };

  render() {
    const { value } = this.props;

    const btnClass = value ? css.innerActive : css.innerEnabled;

    return (
      <div
        data-cwid={this.props.cwId}
        onBlur={this.props.onBlur}
        style={this.props.style}
        className={this.props.className ? cx(css.wrap, this.props.className) : css.wrap}
        tabIndex={this.props.tabIndex}
        onClick={this.handleClick}
        onKeyPress={this.handleKeyPress}
        onKeyDown={this.handleKeyDown}
        onKeyUp={this.handleKeyUp}
        ref={(input) => this.cwButton = input}
        onFocus={this.props.onFocus}
      >
        <div className={btnClass}>
          {this.props.icon ? <CwImage src={this.props.icon} /> : null}
          {this.props.text}
          {this.props.rightIcon ? <CwImage src={this.props.rightIcon} /> : null}
        </div>
      </div>
    );
  };
}

CwToggleButton.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: PropTypes.string,
  /**
   * Text next to checkbox
   */
  text: PropTypes.string,
  /**
   * Callback function when checkbox value is changed
   */
  onChange: PropTypes.func,
  /**
   * Used to check a checkbox
   */
  value: PropTypes.bool,
  /**
   * Used to control tab order
   */
  tabIndex: PropTypes.number,
  /**
   * Callback function that is fired when the component is focused
   */
  onFocus: PropTypes.func,
  /**
   * Callback function that is fired when the component is blurred
   */
  onBlur: PropTypes.func,
 /**
  * Optional icon placed on right side of button
  */
  rightIcon: PropTypes.string,
  /**
   * Optional icon placed on left side of button
   */
  icon: PropTypes.string,
  /**
   * Object of with id, name used to identify the toggle button
   */
  item: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]),
    name: PropTypes.string
  }),
  /**
   * Unused, added to satisfy pod element check
   */
  invalid: PropTypes.bool,
};

CwToggleButton.defaultProps = {
  tabIndex: 0,
};

export default CwToggleButton;


// WEBPACK FOOTER //
// ./src/components/cwtogglebutton/CwToggleButton.jsx